import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import VueYouTubeEmbed from 'vue-youtube-embed'
import Vuelidate from 'vuelidate' 
import Toasted from 'vue-toasted'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import 'video.js/dist/video-js.min.css'
import 'videojs-youtube/dist/Youtube.min.js'
import KabLoader from "@/components/KabLoader"

Vue.component('kab-loader', KabLoader)

Vue.use(Loading)
Vue.use(VuePlyr, {
  plyr: {}
})
Vue.use(Toasted)
Vue.use(Vuelidate)
Vue.use(VueYouTubeEmbed)
Vue.use(VueMaterial)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
